<li class="noselect pointer menu-item" routerLink="{{ route }}" [routerLinkActive]="['selected']">
  <span class="menu-item-text">{{ label }}</span>
</li>
